export default class LicensePlateRotationSchemeController {
    constructor(resource) {
        this._resource = resource
    }

    async getById(id){
      return await this._resource(`rotation`).getById(id)
        .then( res => res.body )
    }

    async getAll(){
      return await this._resource(`rotation`).get()
        .then( res => res.body )
    }

    async delete(id){
      return await this._resource(`rotation/${id}`).delete(id)
        .then( res => res.body )
    }

    async update(model){
      return await this._resource(`rotation`).update(model)
        .then( res => res.body )
    }

    async create(model){
      return await this._resource(`rotation`).save(model)
        .then( res => res.body )
    }
}
